import styled from 'styled-components';
import Colors from '../../constants/Colors';

const FavBg = styled.div`
  display: grid;
  height: 100%;
  background: ${Colors.darkBlueGray};
`;

const FavBounds = styled.div`
  padding: 10px;
`;

const FavGrid = styled.div`
  display: grid;
  grid-template-columns: 320px 1fr;
  grid-gap: 10px;
  height: 100%;
`;

export { FavBg, FavBounds, FavGrid };



// WEBPACK FOOTER //
// ./src/components/Favorites/FavUI.tsx